module.exports = __webpack_public_path__ + "img/toLoginPage.8b97c8b7.png";